import React from 'react';
import { alpha, useTheme } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import CheckList from '../../CherrySoftware/components/CheckList';
import SectionHeader from '../../CherrySoftware/components/SectionHeader';
import GlassCard from '../../CherrySoftware/components/GlassCard';
import PriceVatDisclaimer from 'common/PriceVatDisclaimer';
import handleOpenWhatsApp from 'services/whatsappService';
import { inversion, cierre } from '../sortilegioContent';

const Inversion = () => {
  const theme = useTheme();

  return (
    <Box id="inversion" py={{ xs: 8, md: 10 }}>
      <SectionHeader
        overline={inversion.overline}
        title={inversion.title}
        subtitle={inversion.subtitle}
        icon="money"
        align="left"
        maxWidth="100%"
      />
      <Grid container spacing={3} alignItems="stretch">
        {inversion.plans.map((plan) => (
          <Grid item xs={12} md={6} key={plan.id}>
            <GlassCard
              hover={false}
              accentPalette={plan.recommended ? 'secondary' : 'primary'}
              sx={plan.recommended ? {
                border: `2px solid ${alpha(theme.palette.secondary.main, 0.45)}`,
                bgcolor: alpha(theme.palette.common.white, 0.96),
              } : undefined}
            >
              <Box p={{ xs: 3, md: 4 }}>
                <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                  <Typography variant="h6" sx={{ fontWeight: 800 }}>
                    {plan.name}
                  </Typography>
                  {plan.recommended ? (
                    <Chip
                      label="Recomendado"
                      size="small"
                      sx={{
                        fontWeight: 800,
                        bgcolor: theme.palette.secondary.main,
                        color: theme.palette.common.white,
                      }}
                    />
                  ) : null}
                </Box>
                <Box display="flex" alignItems="baseline" mb={3}>
                  <Typography
                    sx={{
                      fontWeight: 800,
                      fontSize: { xs: '2.4rem', md: '3rem' },
                      letterSpacing: '-0.04em',
                      lineHeight: 1,
                    }}
                  >
                    {plan.price}
                  </Typography>
                  <Typography color="textSecondary" sx={{ ml: 1.25, fontWeight: 600 }}>
                    {plan.period}
                  </Typography>
                </Box>
                <CheckList items={plan.includes} dense />
                <Button
                  fullWidth
                  variant={plan.recommended ? 'contained' : 'outlined'}
                  color={plan.recommended ? 'secondary' : 'primary'}
                  size="large"
                  sx={{ mt: 3, py: 1.4, fontWeight: 700 }}
                  onClick={() =>
                    handleOpenWhatsApp(
                      null,
                      `${cierre.whatsappMessage} Me interesa el ${plan.name} (${plan.price}/mes).`,
                    )
                  }
                >
                  Elegir {plan.name}
                </Button>
              </Box>
            </GlassCard>
          </Grid>
        ))}
      </Grid>

      <Box
        mt={4}
        p={3}
        borderRadius={3}
        bgcolor={alpha(theme.palette.primary.main, 0.06)}
        border={`1px solid ${alpha(theme.palette.primary.main, 0.1)}`}
      >
        <Typography color="textSecondary" sx={{ lineHeight: 1.7 }}>
          {inversion.adsNote}
        </Typography>
        <PriceVatDisclaimer align="left" sx={{ mt: 1.5, mx: 0 }} />
      </Box>
    </Box>
  );
};

export default Inversion;
